"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    menuVariants: ()=>menuVariants
});
const tv_cjs_namespaceObject = require("../../variants/tv.cjs");
const menuVariants = (0, tv_cjs_namespaceObject.tv)({
    slots: {
        root: '',
        trigger: 'bg-primary-1 text-primary-13 text-body1 border-primary-6 focus-visible:outline-primary-8 focus-visible:shadow-input-focus hover:border-primary-10 hover:shadow-input-hover disabled:bg-primary-2 disabled:border-primary-5 disabled:text-primary-6 relative flex items-center justify-center gap-2 rounded-xl border px-4 py-2 hover:cursor-pointer disabled:cursor-not-allowed',
        triggerIcon: 'text-primary-10 flex',
        portal: '',
        positioner: 'z-[50]',
        popup: 'bg-primary-1 shadow-overlay-md animate-in fade-in-0 zoom-in-95 slide-in-from-top-2 !max-h-[80vh] min-w-[var(--anchor-width)] rounded-xl p-[4px] outline-none duration-150',
        arrow: 'fill-primary-1 stroke-primary-6 stroke-1',
        item: 'text-primary-13 text-body2 focus-visible:outline-primary-8 [&:hover,&:focus]:bg-primary-2 disabled:text-primary-6 disabled:[&:hover,&:focus]:bg-transparent flex min-h-[40px] w-full cursor-pointer items-center justify-between gap-[12px] rounded-lg px-[12px] py-[8px] hover:outline-none focus-visible:outline focus-visible:outline-2 disabled:cursor-not-allowed',
        itemIcon: 'text-primary-10 mr-[12px] flex-shrink-0',
        itemText: 'w-full',
        itemSuffix: 'text-body3 text-primary-10 flex-shrink-0',
        separator: 'bg-primary-6 my-[4px] h-[1px] w-full',
        group: '',
        groupLabel: 'text-primary-10 text-body3 px-[12px] py-[8px] font-medium',
        radioGroup: '',
        radioItem: 'text-primary-13 text-body2 focus-visible:outline-primary-8 [&:hover,&:focus]:bg-primary-2 flex min-h-[40px] w-full cursor-pointer items-center justify-between gap-[12px] rounded-lg px-[12px] py-[8px] hover:outline-none focus-visible:outline focus-visible:outline-2',
        radioIndicator: 'flex h-[20px] w-[20px] items-center justify-center',
        checkboxItem: 'text-primary-13 text-body2 focus-visible:outline-primary-8 [&:hover,&:focus]:bg-primary-2 flex min-h-[40px] w-full cursor-pointer items-center justify-between gap-[12px] rounded-lg px-[12px] py-[8px] hover:outline-none focus-visible:outline focus-visible:outline-2',
        checkboxIndicator: 'flex h-[20px] w-[20px] items-center justify-center',
        submenuRoot: '',
        submenuTrigger: 'text-primary-13 text-body2 focus-visible:outline-primary-8 [&:hover,&:focus]:bg-primary-2 flex min-h-[40px] w-full cursor-pointer items-center justify-between gap-[12px] rounded-lg px-[12px] py-[8px] hover:outline-none focus-visible:outline focus-visible:outline-2',
        submenuArrow: 'text-primary-10 ml-auto flex-shrink-0'
    },
    variants: {
        size: {
            sm: {
                trigger: 'text-body3 h-[32px] px-3 py-1.5',
                popup: 'text-body3',
                item: 'text-body3 min-h-[32px] px-[8px] py-[4px]',
                itemIcon: 'mr-[8px]',
                groupLabel: 'text-body4 px-[8px] py-[4px]',
                radioItem: 'text-body3 min-h-[32px] px-[8px] py-[4px]',
                checkboxItem: 'text-body3 min-h-[32px] px-[8px] py-[4px]',
                submenuTrigger: 'text-body3 min-h-[32px] px-[8px] py-[4px]'
            },
            md: {},
            lg: {
                trigger: 'text-body1 h-[56px] px-6 py-3',
                item: 'text-body1 min-h-[48px] px-[16px] py-[12px]',
                itemIcon: 'mr-[16px]',
                groupLabel: 'text-body2 px-[16px] py-[12px]',
                radioItem: 'text-body1 min-h-[48px] px-[16px] py-[12px]',
                checkboxItem: 'text-body1 min-h-[48px] px-[16px] py-[12px]',
                submenuTrigger: 'text-body1 min-h-[48px] px-[16px] py-[12px]'
            }
        },
        open: {
            true: {
                trigger: 'border-primary-8 shadow-input-focus'
            }
        },
        disabled: {
            true: {
                trigger: 'bg-primary-2 border-primary-5 text-primary-6 hover:border-primary-5 cursor-not-allowed hover:shadow-none',
                triggerIcon: 'text-primary-6'
            }
        },
        itemSelected: {
            true: {
                item: 'bg-primary-4 [&:hover,&:focus]:bg-primary-4',
                radioItem: 'bg-primary-4 [&:hover,&:focus]:bg-primary-4',
                checkboxItem: 'bg-primary-4 [&:hover,&:focus]:bg-primary-4'
            }
        },
        itemDisabled: {
            true: {
                item: 'text-primary-6 [&:hover,&:focus]:bg-transparent cursor-not-allowed',
                itemIcon: 'text-primary-6',
                itemSuffix: 'text-primary-6',
                radioItem: 'text-primary-6 [&:hover,&:focus]:bg-transparent cursor-not-allowed',
                checkboxItem: 'text-primary-6 [&:hover,&:focus]:bg-transparent cursor-not-allowed'
            }
        },
        fullWidth: {
            true: {
                trigger: 'w-full'
            }
        }
    },
    compoundVariants: [
        {
            open: true,
            disabled: true,
            class: {
                trigger: 'border-primary-5 shadow-none'
            }
        }
    ],
    defaultVariants: {
        size: 'md'
    }
});
exports.menuVariants = __webpack_exports__.menuVariants;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "menuVariants"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
